export const LoginTranslations = {
  LOGIN_EMAIL_INPUT: 'Email adres',
  LOGIN_PASSWORD_INPUT: 'Wachtwoord',
  LOGIN_BUTTON_TEXT: 'Inloggen',

  LOGIN_NO_SUGARDADDY_ERROR_TITLE: 'Foutje',
  LOGIN_NO_SUGARDADDY_ERROR_MESSAGE: 'Het lijkt er op dat je geen sugardaddy bent :('
};
